











import Vue from "vue";
import Component from "vue-class-component";
import SideMenu from "@/components/navigation/side-menu.vue";
import Toasts from "@/components/layout/toasts.vue";
import Navbar from "@/components/navigation/navbar.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "app",
    components: {
        SideMenu,
        Toasts,
        Navbar,
    },
})
export default class App extends Vue {}
